import React from 'react';
import './Navbar.css';
import { Link } from 'react-router'
import {slugify, jumpToSection} from '../resources/utils/utilities';
import R from 'ramda';
import classNames from 'classnames';

export function toggleSubnavOpen(bool) {
  return function update() {
    return { subnavVisible: bool }
  }
}

class NavbarMainItem extends React.Component {
  constructor() {
    super();
    this.state = {
      subnavVisible: false,
    }
  }

  createPageLink(subnavItem, index) {
    function aboutOrCourses() {
      return (subnavItem === 'Erin Walerko' || subnavItem === 'Linda Vollmer') ?
        'about' : 'courses';
    }

    return (
      <li key={index}>
        <Link to={`/${aboutOrCourses()}/${slugify(subnavItem)}`} onClick={(e) => {this.props.handleToggleMobileNavigationMenu(); this.handleToggleSubnavClosed();}}>{subnavItem}</Link>
      </li>
    )
  }

  getSubnavLink(subnavItems) {
    const subnavClasses = classNames('inner-ul', 'subnav-list',
      {'navbar-subnav-hide': R.not(R.prop('subnavVisible', this.state)),
       'navbar-subnav-show': R.prop('subnavVisible', this.state),
       'open': R.prop('mobileNavOpen', this.props)
      }
    );
    return (
      <ul className={subnavClasses}>
        {subnavItems.map((subnavItem, index) => this.createPageLink(subnavItem, index))}
      </ul>
    )
  }

  getLinkToMainPageSection(navItemTitle) {
    const linkSlug = `#${slugify(navItemTitle)}`;
    if (window.location.pathname === '/') {
      return <a href={linkSlug} onClick={(e) => {jumpToSection(linkSlug, e); this.props.handleToggleMobileNavigationMenu()}} className='main-nav-link'>{navItemTitle}</a>
    } else {
      return <Link to={{pathname: '/', hash: linkSlug}} className='main-nav-link'>{navItemTitle}</Link>
    }
  }

  isMobileMenuDisplayed() {
    return getComputedStyle(document.querySelector('.toggleNav'), null).display === 'block';
  }

  isNotMobileDisplayed() {
    return R.not(this.isMobileMenuDisplayed());
  }

  handleToggleSubnavOpen() {
    if (this.isNotMobileDisplayed()) {
      this.setState(toggleSubnavOpen(true));
    }
  }

  handleToggleSubnavClosed() {
    if (this.isNotMobileDisplayed()) {
      this.setState(toggleSubnavOpen(false));
    }
  }

  render() {
    const navLinksLiClasses = classNames(
      'nav-links',
      {'open': this.props.mobileNavOpen}
    )
    const navItem = R.prop('navItem', this.props);
    const linkToMainPageSection = this.getLinkToMainPageSection(navItem.title);
    let subnav = '';
    if (navItem.subnav) { subnav = this.getSubnavLink(navItem.subnav); }
    return (
      <li className={navLinksLiClasses} onMouseEnter={() => this.handleToggleSubnavOpen()} onMouseLeave={() => this.handleToggleSubnavClosed()}>
        {linkToMainPageSection}
        {subnav}
      </li>
    )
  }
}

NavbarMainItem.propTypes = {
  mobileNavOpen: React.PropTypes.bool.isRequired,
  navItem: React.PropTypes.object.isRequired,
  handleToggleMobileNavigationMenu: React.PropTypes.func.isRequired,
}

export default NavbarMainItem;



// WEBPACK FOOTER //
// ./src/components/NavbarMainItem.js